import { Datepicker } from "Components/DatePicker";
import { FlexRow } from "Routes/styled";
import { DateTime } from "luxon";
import { SvgRightLarge } from "melodies-source/Svgs/RightLarge";
import { TextInput } from "melodies-source/TextInput";
import styled from "styled-components";

interface DateInputProps {
  type: "date";
  start: DateTime;
  end: DateTime;
  onChange: (v: [DateTime, DateTime]) => void;
}

interface NumberInputProps {
  type: "number";
  start: number;
  end: number;
  onChange: (v: [number, number]) => void;
}

type Props = DateInputProps | NumberInputProps;

export const RangeInput = ({
  type: inputType,
  start,
  end,
  onChange,
}: Props) => {
  const getInputComponent = (type: "start" | "end") => {
    switch (inputType) {
      case "date":
        return (
          <Datepicker
            type="dateOnly"
            value={type === "start" ? start : end}
            onChange={(v) =>
              onChange(
                type === "start"
                  ? [v ? v.startOf("day") : undefined, end ? end.endOf("day") : undefined]
                  : [start ? start.startOf("day") : undefined, v ? v.endOf("day") : undefined]
              )
            }
          />
        );
      case "number":
        return (
          <TextInput
            type="number"
            value={`${type === "start" ? start : end || ""}`}
            onChange={(v) => {
              return onChange(
                type === "start"
                  ? [v === "" ? undefined : +v, end]
                  : [start, v === "" ? undefined : +v],
              );
            }}
            placeholder={type === "start" ? "Enter minimum" : "Enter maximum"}
          />
        );

      default:
        return null;
    }
  };

  return (
    <Container>
      {getInputComponent("start")}
      <SvgRightLarge />
      {getInputComponent("end")}
    </Container>
  );
};

const Container = styled(FlexRow)`
  width: 100%;
  margin: 10px 0 20px;

  & > svg {
    width: 55px;
    margin: 10px 3vw -10px;
    color: #dedede;
    ${({ theme }) => theme.mediaQueries.mobile} {
      margin: 10px auto;
    }
  }
  & > div {
    width: 100%;
    font-size: 12px !important;
  }
  & > div > div {
    width: 100%;
  }
  ${({ theme }) => theme.mediaQueries.mobile} {
    flex-direction: column;
  }
`;
